import { ApiBind, Common } from './common.model';

export class SDKVersion extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'value' })
  value: string;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }
}
